import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { ResumenComponent } from './components/usuario/resumen/resumen.component';
import { FacturasComponent } from './components/informacion/facturas/facturas.component';
import { ContratosComponent } from './components/informacion/contratos/contratos.component';
import { SuministroComponent } from './components/informacion/suministro/suministro.component';
import { PerfilComponent } from './components/usuario/perfil/perfil.component';
import { CchComponent } from './components/cch/cch.component';
import { PasswordComponent } from './components/usuario/password/password.component';
import { RecordarContrasenaComponent } from './components/recordar-contrasena/recordar-contrasena.component';
import { SalirComponent } from './components/usuario/salir/salir.component';
import { InicioComponent } from './components/usuario/inicio/inicio.component';
import { PerfilContratoComponent } from './components/informacion/perfil-contrato/perfil-contrato.component';
import { PerfilCupsComponent } from './components/informacion/perfil-cups/perfil-cups.component';
import { Error404Component } from './components/errores/error404/error404.component';
import { PerfilIdentidadComponent } from './components/informacion/perfil-identidad/perfil-identidad.component';
import { GraficosComponent } from './components/informacion/graficos/graficos.component';
import { InformacionInteresComponent  } from './components/informacion/informacion-interes/informacion-interes.component';

const APP_ROUTES: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'resumen', component: ResumenComponent },
  { path: 'perfil', component: PerfilComponent },
  { path: 'inicio', component: InicioComponent },
  { path: 'informacion/informacion', component: InformacionInteresComponent },
  { path: 'informacion/facturas', component: FacturasComponent },
  { path: 'informacion/contratos', component: ContratosComponent },
  { path: 'informacion/suministro', component: SuministroComponent },
  { path: 'informacion/graficos/:idcups/:idcliente/:idcontrato', component: GraficosComponent },
  { path: 'informacion/perfil/contrato/:idcontrato', component: PerfilContratoComponent },
  { path: 'informacion/perfil/cups/:idcups', component: PerfilCupsComponent },
  { path: 'informacion/perfil/cliente/:idcliente', component: PerfilIdentidadComponent },
  { path: 'informacion/facturas/:idcontrato', component: FacturasComponent },
  { path: 'cch', component: CchComponent },
  { path: 'password', component: PasswordComponent },
  { path: 'recordarcontrasena', component: RecordarContrasenaComponent },
  { path: 'salir', component: SalirComponent },
  { path: '**', component: LoginComponent }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { relativeLinkResolution: 'legacy' });
